var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text-justify" }, [
    _vm.text.length > 100
      ? _c("div", [
          !_vm.readMore
            ? _c("p", { staticClass: "p" }, [
                _vm._v(" " + _vm._s(_vm.text.slice(0, 100)) + " "),
                _c(
                  "span",
                  {
                    staticClass: "text-info cursor-pointer",
                    on: {
                      click: function($event) {
                        return _vm.changeReamMoreStatus()
                      }
                    }
                  },
                  [_vm._v(" ...leer más ")]
                )
              ])
            : _vm._e(),
          _vm.readMore
            ? _c("p", { staticClass: "p" }, [
                _vm._v(" " + _vm._s(_vm.text) + " "),
                _c(
                  "span",
                  {
                    staticClass: "text-info cursor-pointer",
                    on: {
                      click: function($event) {
                        return _vm.changeReamMoreStatus()
                      }
                    }
                  },
                  [_vm._v(" ...leer menos ")]
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm.text.length <= 100
      ? _c("div", [_vm._v(" " + _vm._s(_vm.text) + " ")])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }